import type { ListPadding } from '@src/component/keyboard-list/KeyboardListController'
import type PhoneNumberSelectorController from '@src/component/phone-number-selector/PhoneNumberSelectorController'
import { PhoneNumberSelectorKeyboardListController } from '@src/component/phone-number-selector/PhoneNumberSelectorController'

export default class ForwardPhoneNumberSelectorKeyboardListController extends PhoneNumberSelectorKeyboardListController {
  override readonly itemHeight = 45
  override maxViewportHeight: number | null = 300
  override readonly listPadding: ListPadding = { top: 2, bottom: 2 }

  constructor(protected override controller: PhoneNumberSelectorController) {
    super(controller)
  }
}
